import {currencyFormatter} from '@homeaway/hacommons-i18n';

const hasData = (data) => {
    return Array.isArray(data) && data.length > 0;
};

function getFormattedPricing(pricing) {
    if (!pricing.price) {
        return {
            noPrice: true,
            listingId: pricing.listingId,
        };
    }

    const shortLabel = currencyFormatter.formatNumber({
        currencyCode: pricing.price.currency,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
        value: pricing.price.value,
    });

    return {
        listingId: pricing.listingId,
        currency: pricing.price.currency,
        perNight: 'avg/night',
        shortLabel,
    };
}

const updateListingsWithNewPrice = (listings, pricings) => {
    listings.forEach((listing) => {
        pricings.forEach((pricing) => {
            if (listing.tripleId === pricing.listingId) {
                if (pricing.noPrice) {
                    listing.noPrice = true;
                } else {
                    listing.price = pricing;
                }
            }
        });
    });
};

const updatePricings = (listings, pricings = []) => {
    if (!hasData(pricings)) return;
    const formattedPricings = pricings.map((pricing) =>
        getFormattedPricing(pricing)
    );
    updateListingsWithNewPrice(listings, formattedPricings);
};

const getListingIds = (listings) => {
    return listings?.map((listing) => listing.tripleId) || [];
};

export {
    hasData,
    getFormattedPricing,
    updatePricings,
    updateListingsWithNewPrice,
    getListingIds,
};
